import React, { useState } from 'react';
import './FAQSection.css';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "How long does it take to implement an AI solution?",
      answer: "Implementation timelines vary based on project complexity. Simple solutions like chatbots can be deployed in 2-4 weeks, while complex computer vision or predictive analytics systems typically take 8-16 weeks. We provide detailed project timelines during our initial consultation."
    },
    {
      question: "What industries do you specialize in?",
      answer: "We have deep expertise across healthcare, finance, manufacturing, and retail sectors. Our solutions are designed to address industry-specific challenges, from medical diagnostics and fraud detection to quality control and customer service automation."
    },
    {
      question: "Do you provide ongoing support and maintenance?",
      answer: "Yes, we offer comprehensive support packages including 24/7 monitoring, regular updates, performance optimization, and technical support. Our team ensures your AI systems continue to perform optimally and adapt to changing business needs."
    },
    {
      question: "How do you ensure data security and privacy?",
      answer: "Data security is our top priority. We implement enterprise-grade encryption, comply with GDPR, HIPAA, and other relevant regulations, and follow best practices for data handling. All client data is processed securely with strict access controls and audit trails."
    },
    {
      question: "What's the typical ROI for AI implementations?",
      answer: "Our clients typically see ROI within 6-12 months. Benefits include 30-50% efficiency improvements, 40-70% reduction in manual tasks, and significant cost savings. We provide detailed ROI projections during the planning phase and track metrics post-implementation."
    },
    {
      question: "Can AI solutions integrate with existing systems?",
      answer: "Absolutely. Our solutions are designed for seamless integration with existing enterprise systems, databases, and workflows. We work with popular platforms like Salesforce, SAP, Oracle, and custom systems through APIs and middleware."
    },
    {
      question: "Do you offer training for our team?",
      answer: "Yes, we provide comprehensive training programs tailored to different user levels - from executives understanding AI strategy to technical teams managing day-to-day operations. Training includes documentation, workshops, and ongoing support."
    },
    {
      question: "How do you handle AI model accuracy and bias?",
      answer: "We implement rigorous testing protocols, use diverse training datasets, and continuously monitor model performance. Our ethical AI framework ensures fairness and transparency, with regular audits to identify and mitigate potential biases."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      <div className="faq-container">
        <div className="faq-header">
          <h2 className="faq-title">Frequently Asked Questions</h2>
          <p className="faq-subtitle">
            Get answers to common questions about our AI solutions and implementation process
          </p>
        </div>

        <div className="faq-grid">
          <div className="faq-list">
            {faqs.map((faq, index) => (
              <div key={index} className={`faq-item ${openIndex === index ? 'active' : ''}`}>
                <button
                  className="faq-question"
                  onClick={() => toggleFAQ(index)}
                  aria-expanded={openIndex === index}
                >
                  <span className="question-text">{faq.question}</span>
                  <span className="faq-icon">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className={`chevron ${openIndex === index ? 'rotated' : ''}`}
                    >
                      <path
                        d="M6 9L12 15L18 9"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </button>
                <div className={`faq-answer ${openIndex === index ? 'expanded' : ''}`}>
                  <div className="answer-content">
                    <p>{faq.answer}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="faq-contact">
            <div className="contact-card">
              <div className="contact-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22 12H18L15 21L9 3L6 12H2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3 className="contact-title">Still have questions?</h3>
              <p className="contact-description">
                Our AI experts are here to help you understand how our solutions can transform your business.
              </p>
              <a href="/contact-us" className="contact-button">
                Schedule a Consultation
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
